var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 13.3333H20L19.6667 16H17.3333V24H13.875V16H12V13.3333H13.875V11.5417C13.875 10.375 14.1667 9.5 14.75 8.91667C15.3333 8.30556 16.3056 8 17.6667 8H20V10.6667H18.5833C18.0556 10.6667 17.7083 10.75 17.5417 10.9167C17.4028 11.0833 17.3333 11.3611 17.3333 11.75V13.3333Z",
    fill: "#00A988"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.c86638eedcb45ba7a686738987057845.svg";
export { ForwardRef as ReactComponent };